import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "column",
        gap: "1rem"
    }
});

export default function FlightOps_Ring_Overview() {
    const styles = useStyles();
    
    return (
        <div className={styles.root}>
            Placeholder content.
        </div>
    );
}